import React, { FC, ReactElement } from 'react'
import { ClientCommentFormProps } from './types'
import { CommentForm } from '../CommentForm'
import { UserRole } from 'models/user/user'
import ClientCommentFormMessages from './ClientCommentForm.messages'

export const ClientCommentForm: FC<ClientCommentFormProps> = ({
  commentRecipients,
  orderCommentPath,
  showNotarySmsText,
  csrfToken,
  orderHasParticipants
}): ReactElement => {
  return (
    <CommentForm
      commentRecipients={commentRecipients}
      userRole={UserRole.Client}
      showNotarySmsText={showNotarySmsText}
      toFieldHelpText={ClientCommentFormMessages.TO.HELP}
      toFieldSelectText={ClientCommentFormMessages.TO.SELECT}
      textFieldPlaceHolder={ClientCommentFormMessages.TEXT.PLACEHOLDER}
      orderCommentPath={orderCommentPath}
      csrfToken={csrfToken}
      orderHasParticipants={orderHasParticipants}
    />
  )
}
